const selectDirections = (state) => state.map;

export default selectDirections;
